import { LicenseSection } from "@/components/license/LicenseSection";

// #254: Lizenz-Seite (admin-only). Status + Aktivierung + Refresh + Offline-Import.
export function LicensePage() {
  return (
    <div className="max-w-3xl space-y-5">
      <LicenseSection />
    </div>
  );
}
